//import { AgeGroupModel } from "./ageGroupModel";
//import { DiseaseForGridModel } from "../disease/diseaseForGridModel";
import { DiseaseAdminModel } from "../disease/diseaseAdminModel";
//import { RouteOfAdministrationTypeModel } from "./routeOfAdministrationTypeModel";
import { DosageLevelContentModel } from './dosageLevelContentModel';

export class DosageLevelModel {
  public dosageLevelId: number;
  public dosageContentId: number;
  public ageGroupId?: number;
  public diseaseId: number;
  public roaTypeId?: number;
  public ageRange: string;
  public weightRange: string;
  public singleDose: string;
  public loadingDose: string;
  public maxDailyDose: string;
  public frequencyOfIntake: string;
  public minMaxTimeBetweenIntakes: string;
  public minMaxTitration: string;
  public specificDescription: string;
  public comments: string;
  public uses: string;
  // public ageGroup: AgeGroupModel;
  public disease: DiseaseAdminModel;
  //public roaType: RouteOfAdministrationTypeModel;
  public dosageLevelContent: Array<DosageLevelContentModel>;
}